import { render } from "./LotApproveModal.vue?vue&type=template&id=35101bce&ts=true&lang=pug"
import script from "./LotApproveModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./LotApproveModal.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__